module.exports = __webpack_public_path__ + "static/media/formas_armazenar.47d5cd1d.jpg";